document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('ul.pill-list__container');
  const links = slider.querySelectorAll('a');
  const currentUrl = window.location.pathname;

  let targetLink = null;

  // Trova il link che corrisponde all'URL corrente
  links.forEach((link) => {
    if (link.getAttribute('href') === currentUrl) {
      targetLink = link;
    }
  });

  if (targetLink) {
    const targetItem = targetLink.closest('li');
    const targetOffset = targetItem.offsetLeft - slider.offsetLeft;

    slider.scroll({
      top: 0,
      left: targetOffset,
      behavior: 'smooth',
    });
  }
});
